<template>
    <div>
        <passe_product
            v-for="item in products"
            :key="item.id"
            :data="item"
            :increase="increase"
            :decrease="decrease"
            ></passe_product>
    </div>
</template>

<script>
    import {passes_store} from '../helpers/passesHelper';
    import Endpoints from '../api';

    export default {
        props: {
            data: {
                type: Array,
                required: true
            }
        },

        mounted() {
            passes_store.dispatch("add_products", {products: this.data});
        },

        computed: {
            products() {
                return passes_store.state.products
            }
        },

        methods: {
            increase(item) {
                passes_store.dispatch("increment", {item: item});
            },
            decrease(item) {
                passes_store.dispatch("decrement", {item: item});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ListPasses.vue